// frontend/src/components/leads/archive/archiveAccess.js
//
// WHO may use the lead archive, and the one-shot "open the archive" request -
// pure, so the dashboard and the navbar read the SAME rule.
//
// The archive organises the signed-in user's OWN feed: every customer, and an
// admin in "my leads" mode; never a lapsed account (every archive write from
// one is refused server-side) and never an admin's "all users" view (those
// feeds are their owners' to clear). That is exactly the labels' "viewer"
// source (labelsModel.labelSourceFor), so the rule is defined once there and
// only NAMED here.

import { labelSourceFor } from "../labels/labelsModel";

/**
 * Can this user use the archive in this dashboard scope?
 *
 * @param {object|null} user
 * @param {"mine"|"all"} viewMode the dashboard's admin scope ("mine" for
 *   everyone who is not an admin).
 * @returns {boolean}
 */
export const canUseArchiveIn = (user, viewMode) => labelSourceFor(user, viewMode) === "viewer";

/**
 * Could this ACCOUNT use the archive at all - outside the dashboard, where
 * there is no admin scope yet? An admin qualifies: the archive is their own
 * feed's, so the dashboard serves an archive request in "my leads" - moving
 * an admin out of the "all users" view for it (unsaved, and undone when they
 * leave the archive). A lapsed account never qualifies.
 *
 * @param {object|null} user
 * @returns {boolean}
 */
export const accountMayUseArchive = (user) => canUseArchiveIn(user, "mine");

/**
 * The router location-state key of an "open the archive" request
 * (`navigate("/dashboard", { state: { [OPEN_ARCHIVE_STATE_KEY]: true } })`).
 * State, not a URL param: the dashboard spends it once and replaces the entry
 * without it, so Back and a refresh never re-open the archive.
 */
export const OPEN_ARCHIVE_STATE_KEY = "openArchive";

/**
 * Does this router location carry an "open the archive" request?
 *
 * @param {{state?: unknown}|null|undefined} location
 * @returns {boolean}
 */
export const isOpenArchiveRequest = (location) => {
  const state = location?.state;
  return Boolean(state && typeof state === "object" && state[OPEN_ARCHIVE_STATE_KEY] === true);
};

/** The `navigate` options of an "open the archive" request. */
export const openArchiveNavigation = (replace = false) => ({
  replace,
  state: { [OPEN_ARCHIVE_STATE_KEY]: true },
});
